import React from 'react'
import styled from 'styled-components'

import { LegendItem, legendDataForTimeAtCursor, legendZone } from 'types/RuntimeHistory'

import HoveredSeriesValue from 'pages/Device/ThermostatRthPanel/Legend/HoveredSeriesValue'
import CheckMark from 'pages/Device/ThermostatRthPanel/Legend/CheckMark'
import SeriesLabel from 'pages/Device/ThermostatRthPanel/Legend/SeriesLabel'

import _ from 'underscore'

type Props = {
  legendItem: Required<LegendItem>
  selectedLegendItems: Array<{name: string, series: Array<string>}>
  onSelectCallback: (s, e, n) => void
  onSelectSeriesCallback: (s, e, m) => void
  legendDataForTimeAtCursor: Required<legendDataForTimeAtCursor> | null
  zones: Array<legendZone>
}
const IndoorLegendGroupItem = ({ legendItem, selectedLegendItems, zones, legendDataForTimeAtCursor, onSelectCallback, onSelectSeriesCallback }: Props) => {
  const getLegendData = (zoneName, seriesName) => {
    if (legendDataForTimeAtCursor) {
      const zone = _.find(legendDataForTimeAtCursor.zones, (zone) => zone.name === zoneName)
      if (zone && zone[seriesName]) {
        return zone[seriesName]
      } else {
        return '--'
      }
    }
  }

  const disabled = _.all(zones, zone => !!_.find(zone.zoneItems, series => series.seriesName === legendItem.seriesName)?.emptyDataSet)
  const isSelected = _.any(selectedLegendItems, selectedLegendItem => selectedLegendItem.series.includes(legendItem.seriesName))

  return (
    <S.LegendItem numberOfZones={zones.length}>
      <S.SeriesLabel isSelected={isSelected} series={legendItem} disable={disabled} onSelectSeriesCallback={onSelectSeriesCallback} />
      <S.DisplayValueContainer numberOfZones={zones.length}>
        { zones?.map(zone => {
          const selectedZone = _.find(selectedLegendItems, selectedLegendItem => selectedLegendItem.name === zone.name)
          const isSeriesSelected = selectedZone?.series?.includes(legendItem.seriesName)
          const isEmptyDataSet = _.find(zone.zoneItems, zoneItem => zoneItem.seriesName === legendItem.seriesName)?.emptyDataSet

          return (
            <S.DisplayValue key={zone.name + legendItem.seriesName}>
              {isEmptyDataSet && <S.NoData data-testid={legendItem.seriesName}>No Data</S.NoData>}
              {!isEmptyDataSet && (legendDataForTimeAtCursor
                ? <HoveredSeriesValue isSelected={isSeriesSelected} series={legendItem} getLegendDataCallback={() => getLegendData(zone.name, legendItem.seriesName)} key={legendItem.seriesName + zone.name} />
                : <CheckMark data-testid={`checkmark${legendItem.seriesName}`} isSelected={isSeriesSelected} seriesName={legendItem.seriesName} onSelectCallback={() => onSelectCallback(zone.name, legendItem.seriesName, isSeriesSelected)} key={legendItem.seriesName + zone.name} />)}
            </S.DisplayValue>
          )
        })
      }
      </S.DisplayValueContainer>
    </S.LegendItem>
  )
}

export default IndoorLegendGroupItem

const S = {
  LegendItem: styled.div.withConfig({
    shouldForwardProp: (prop) => !['numberOfZones'].includes(prop)
  })<{ numberOfZones: number }>`
    display: flex;
    margin-bottom: 5px;
  `,
  DisplayValueContainer: styled.div.withConfig({
    shouldForwardProp: (prop) => !['numberOfZones'].includes(prop)
  })<{ numberOfZones: number }>`
    display:  grid;
    grid-template-columns: ${({ numberOfZones }) => `repeat(${numberOfZones},80px );`};
    grid-column-gap: 10px;
  `,
  DisplayValue: styled.div`
    display:  flex;
    margin: auto;
  `,
  NoData: styled.span`
    opacity:  0.4;
  `,
  SeriesLabel: styled(SeriesLabel)`
    margin-right: 10px;
    width: 160px;
  `
}
